<template>
    <div class="module">
        <header class="module__header">
            <h1>User-Agent/Firmware Compatibility</h1>
        </header>

        <section class="module__body">
            <table
                v-if="!isLoading"
                class="firmware-matrix"
            >
                <thead>
                    <tr>
                        <th colspan="4">Create New Association:</th>
                    </tr>
                    <tr>
                        <td>
                            <select
                                v-model="chosenProductId"
                                data-test-id="new-association"
                                style="margin-bottom: 60px"
                            >
                                <option
                                    :value="null"
                                    disabled
                                    selected
                                >
                                    Select a product
                                </option>
                                <option
                                    v-for="product in products"
                                    :key="product.id"
                                    :data-test-id="`new-option-{{ product.user_agent }}`"
                                    :value="product.id"
                                >
                                    {{ product.name }}
                                </option>
                            </select>
                        </td>
                        <td>
                            <input
                                v-model="version"
                                type="text"
                                maxlength="10"
                                placeholder="Version"
                            />
                        </td>
                        <td>
                            <ToggleButtonList
                                :selectedValues="compatibleFirmware"
                                :allValues="sortedFirmware"
                                @update="updateChosenFirmware"
                            />
                        </td>
                        <td>
                            <button
                                class="btn btn-primary"
                                data-test-id="create-button"
                                @click="createUserAgent"
                            >
                                Create
                            </button>
                        </td>
                    </tr>
                    <tr>
                        <th>Product</th>
                        <th>Version</th>
                        <th>Compatible Firmware</th>
                        <th></th>
                    </tr>
                    <tr>
                        <td>
                            <select
                                v-model="productIdFilter"
                                data-test-id="product-filter-product"
                            >
                                <option
                                    :value="null"
                                    data-test-id="product-filter-all"
                                >
                                    All
                                </option>
                                <option
                                    v-for="product in products"
                                    :key="product.id"
                                    :data-test-id="`product-filter-{{ product.user_agent }}`"
                                    :value="product.id"
                                >
                                    {{ product.name }}
                                </option>
                            </select>
                        </td>
                        <td>
                            <input
                                v-model="versionFilter"
                                data-test-id="product-filter-version"
                                type="text"
                            />
                        </td>
                        <td></td>
                        <td></td>
                    </tr>
                </thead>
                <tbody>
                    <user-agent
                        v-for="(userAgent, index) in sortedAndFilteredUserAgents"
                        :key="userAgent.id"
                        :data-test-id="`association-${index}`"
                        :userAgent="userAgent"
                        :firmware="sortedFirmware"
                        @deleteUserAgent="deleteUserAgent(userAgent.id)"
                        @updateUserAgentFirmware="userAgent.firmware = $event"
                    />
                </tbody>
            </table>
        </section>
    </div>
</template>

<script>
import * as _ from 'lodash'
import canToast from '@/mixins/canToast'
import ToggleButtonList from '@/components/ToggleButtonList.vue'
import UserAgent from './UserAgent.vue'

export default {
    components: {
        UserAgent,
        ToggleButtonList,
    },

    mixins: [canToast],

    data() {
        return {
            chosenProductId: null,
            version: null,
            products: [],
            compatibleFirmware: [],
            firmware: [],
            userAgents: [],
            productIdFilter: null,
            versionFilter: '',
            isLoading: true,
        }
    },

    computed: {
        sortedFirmware() {
            return [...this.firmware].sort((a, b) => (a.version > b.version ? 1 : -1))
        },

        sortedAndFilteredUserAgents() {
            let filtered = this.userAgents

            if (this.productIdFilter !== null) {
                filtered = filtered.filter((u) => {
                    return u.product.id === this.productIdFilter
                })
            }
            if (this.versionFilter) {
                filtered = filtered.filter((u) => {
                    return u.version.indexOf(this.versionFilter) !== -1
                })
            }

            return _.sortBy(filtered, ['product', 'version'])
        },
    },

    mounted() {
        const firmwareRequest = this.$http.get('firmware?per_page=1000').then(({ data }) => {
            this.firmware = data.data
        })
        const userAgentsRequest = this.$http.get('user-agents').then(({ data }) => {
            this.userAgents = data
        })
        const productsRequest = this.$http.get('products/all').then(({ data }) => {
            this.products = data
        })

        Promise.all([firmwareRequest, productsRequest, userAgentsRequest]).then(() => {
            this.isLoading = false
        })
    },

    methods: {
        createUserAgent() {
            this.$http
                .post('user-agents', {
                    product_id: this.chosenProductId,
                    version: this.version,
                    firmware: this.compatibleFirmware,
                })
                .then(({ data }) => {
                    // Reset form inputs
                    this.chosenProductId = null
                    this.version = null
                    this.compatibleFirmware = []

                    // Add new user agent to table and alert user
                    this.userAgents.push(data)
                    this.toast('User-agent entry successfully added!')
                })
                .catch((error) => {
                    const errorMessage = Object.values(error.response.data.errors).join('\n')
                    this.toast(errorMessage, 'error')
                })
        },

        deleteUserAgent(id) {
            this.userAgents = this.userAgents.filter((u) => u.id !== id)
        },

        updateChosenFirmware(firmwareIds) {
            this.compatibleFirmware = firmwareIds
        },
    },
}
</script>
<style lang="scss">
.toggle-button-list {
    &:not(:last-child) {
        margin-top: 5px !important;
        margin-bottom: 5px !important;
    }
}
</style>
